import { defineStore } from "pinia";
import axios from "axios";

export const useTwitchStore = defineStore("twitch", {
  state: () => ({
    isLive: false,
    stream: null,
    loaded: false,
    loading: false,
  }),

  actions: {
    async checkLive() {
      /*
       * Don't make another request if one
       * is already running.
       */
      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        const response = await axios.get(
          process.env.VUE_APP_API_URL + "twitch/live"
        );

        this.isLive = response.data.live === true;

        this.stream = response.data.stream || null;

        this.loaded = true;
      } catch (error) {
        console.error("Unable to check Twitch status", error);

        this.isLive = false;
        this.stream = null;
        this.loaded = true;
      } finally {
        this.loading = false;
      }
    },
  },
});
